import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import { CountUp } from "use-count-up";
import useMobile from "../../../hooks/useMobile";
import useTab from "../../../hooks/useTab";

// Pending, Approved, Active, Rejected, Expired

const StatusCount = (props: {
  Title?: string;
  pendingCount: number;
  approveCount: number;
  activeCount: number;
  rejectedCount: number;
  expiredCount: number;
  selectedStatus?: string[];
  setSelectedStatus?: Dispatch<SetStateAction<string[]>>;
}) => {
  const [startCount, setStartCount] = useState(false);
  const counterRef = useRef<HTMLUListElement>(null);
  const mobile = useMobile();
  const tab = useTab();
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.1 },
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const toggleStatus = (status: string) => {
    if (!props.setSelectedStatus) return;

    props.setSelectedStatus(
      (prev) =>
        prev.includes(status)
          ? prev.filter((s) => s !== status) // unselect
          : [...prev, status], // select
    );
  };
  return (
    <section
      className="events-page"
      style={{
        padding: "0px 0px 20px 0px",
        // marginTop: (!mobile && !tab) ? "88px" : "unset",
        marginLeft: !mobile && !tab ? "240px" : "unset",
      }}
    >
      <div className="container">
        {props.Title && (
          <div
            className="section-title custom-text-center"
            style={{ marginBottom: "unset" }}
          >
            <h2 className="section-title__title custom-user-section-title">
              {props.Title}
            </h2>
          </div>
        )}
        <div className="col-xl-12 col-lg-12">
          <div>
            <ul
              ref={counterRef}
              className="we-change__counter list-unstyled"
              style={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                gap: !mobile && !tab ? "15px" : "unset",
              }}
            >
              <li
                className={`we-change__counter-single custom-we-change__counter-single wow fadeInUp ${
                  !mobile && "custom-we-change__counter-status"
                }`}
                data-wow-delay="100ms"
                style={{
                  ...(mobile ? { width: "100%" } : {}),
                  ...(props.selectedStatus?.includes("Pending")
                    ? { backgroundColor: "#a6d7fb" }
                    : {}),
                  ...(props.Title ? { cursor: "pointer" } : {}),
                }}
                onClick={() =>
                  props.Title && toggleStatus("Pending")
                }
              >
                <div
                  className={`we-change__counter-icon ${
                    mobile && "custom-we-change__counter-icon"
                  }`}
                >
                  {/* <i class="fa-solid fa-user-clock"></i> */}
                  <span
                    className="icon-hour-glass"
                    style={{ fontSize: "48px", color: "#ffa415" }}
                  ></span>
                  {/* <span className="fa-hourglass-start" style={{fontSize: "48px"}}></span> */}
                </div>
                <div
                  className={`we-change__counter-content ${
                    mobile && "custom-we-change__counter-content"
                  } ${!mobile && "custom-we-change__counter-status-content"}`}
                >
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={props?.pendingCount}
                      duration={3}
                    />
                  </h3>
                  <p
                    className={`we-change__counter-text custom-we-change__counter-text ${
                      !mobile && "custom-we-change__counter-status-text"
                    }`}
                  >
                    Pending
                  </p>
                </div>
              </li>
              <li
                className={`we-change__counter-single custom-we-change__counter-single wow fadeInUp ${
                  !mobile && "custom-we-change__counter-status"
                }`}
                data-wow-delay="200ms"
                style={{
                  ...(mobile ? { width: "100%" } : {}),
                  ...(props.selectedStatus?.includes("Approved")
                    ? { backgroundColor: "#a6d7fb" }
                    : {}),
                  ...(props.Title ? { cursor: "pointer" } : {}),
                }}
                onClick={() =>
                  props.Title && toggleStatus("Approved")
                }
              >
                <div
                  className={`we-change__counter-icon we-change__counter-icon-clr-extra ${
                    mobile && "custom-we-change__counter-icon"
                  }`}
                >
                  {/* <i class="fa-regular fa-thumbs-up"></i> */}
                  <span
                    className="icon-checkmark"
                    style={{ fontSize: "48px", color: "green" }}
                  ></span>
                </div>
                <div
                  className={`we-change__counter-content ${
                    mobile && "custom-we-change__counter-content"
                  } ${!mobile && "custom-we-change__counter-status-content"}`}
                >
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={props?.approveCount}
                      duration={3}
                    />
                  </h3>
                  <p
                    className={`we-change__counter-text custom-we-change__counter-text ${
                      !mobile && "custom-we-change__counter-status-text"
                    }`}
                  >
                    Approved
                  </p>
                </div>
              </li>
              <li
                className={`we-change__counter-single custom-we-change__counter-single wow fadeInUp ${
                  !mobile && "custom-we-change__counter-status"
                }`}
                data-wow-delay="300ms"
                style={{
                  ...(mobile ? { width: "100%" } : {}),
                  ...(props.selectedStatus?.includes("Active")
                    ? { backgroundColor: "#a6d7fb" }
                    : {}),
                  ...(props.Title ? { cursor: "pointer" } : {}),
                }}
                onClick={() =>
                  props.Title && toggleStatus("Active")
                }
              >
                <div
                  className={`we-change__counter-icon we-change__counter-icon-clr-secondary ${
                    mobile && "custom-we-change__counter-icon"
                  }`}
                >
                  <span
                    className="icon-user"
                    style={{ fontSize: "48px", color: "green" }}
                  ></span>
                </div>
                <div
                  className={`we-change__counter-content ${
                    mobile && "custom-we-change__counter-content"
                  } ${!mobile && "custom-we-change__counter-status-content"}`}
                >
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={props?.activeCount}
                      duration={3}
                    />
                  </h3>
                  <p
                    className={`we-change__counter-text custom-we-change__counter-text ${
                      !mobile && "custom-we-change__counter-status-text"
                    }`}
                  >
                    Active
                  </p>
                </div>
              </li>
              <li
                className={`we-change__counter-single custom-we-change__counter-single wow fadeInUp ${
                  !mobile && "custom-we-change__counter-status"
                }`}
                data-wow-delay="100ms"
                style={{
                  ...(mobile ? { width: "100%" } : {}),
                  ...(props.selectedStatus?.includes("Rejected")
                    ? { backgroundColor: "#a6d7fb" }
                    : {}),
                  ...(props.Title ? { cursor: "pointer" } : {}),
                }}
                onClick={() =>
                  props.Title && toggleStatus("Rejected")
                }
              >
                <div
                  className={`we-change__counter-icon ${
                    mobile && "custom-we-change__counter-icon"
                  }`}
                >
                  <span
                    className="icon-cross1"
                    style={{ fontSize: "48px", color: "red" }}
                  ></span>
                </div>
                <div
                  className={`we-change__counter-content ${
                    mobile && "custom-we-change__counter-content"
                  } ${!mobile && "custom-we-change__counter-status-content"}`}
                >
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={props?.rejectedCount}
                      duration={3}
                    />
                  </h3>
                  <p
                    className={`we-change__counter-text custom-we-change__counter-text ${
                      !mobile && "custom-we-change__counter-status-text"
                    }`}
                  >
                    Rejected
                  </p>
                </div>
              </li>
              <li
                className={`we-change__counter-single custom-we-change__counter-single wow fadeInUp ${
                  !mobile && "custom-we-change__counter-status"
                }`}
                data-wow-delay="100ms"
                style={{
                  ...(mobile ? { width: "100%" } : {}),
                  ...(props.selectedStatus?.includes("Expired")
                    ? { backgroundColor: "#a6d7fb" }
                    : {}),
                  ...(props.Title ? { cursor: "pointer" } : {}),
                }}
                onClick={() =>
                  props.Title && toggleStatus("Expired")
                }
              >
                <div
                  className={`we-change__counter-icon ${
                    mobile && "custom-we-change__counter-icon"
                  }`}
                >
                  <span
                    className="icon-calendar"
                    style={{ fontSize: "48px", color: "darkred" }}
                  ></span>
                </div>
                <div
                  className={`we-change__counter-content ${
                    mobile && "custom-we-change__counter-content"
                  } ${!mobile && "custom-we-change__counter-status-content"}`}
                >
                  <h3 className="odometer">
                    <CountUp
                      isCounting={startCount}
                      end={props?.expiredCount}
                      duration={3}
                    />
                  </h3>
                  <p
                    className={`we-change__counter-text custom-we-change__counter-text ${
                      !mobile && "custom-we-change__counter-status-text"
                    }`}
                  >
                    Expired
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatusCount;
